<template>
	<div>
	</div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    orderStatus: [Array]
  },
  data () {
    return {
      title: '报告生成',
      form: {}
    }
  }
}
</script>

<style module lang="less">

</style>
